import { h, Component } from 'preact'
import styled from 'styled-components'
import Card_ from '../../components/atoms/card'
import arrow from '../../components/atoms/checkbox/arrow.svg'

const InnerHTMLHelper = ({ tagName, html }) =>
  h(tagName, { dangerouslySetInnerHTML: { __html: html } })

/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-tabindex */
/* global requestAnimationFrame */

class ClickCollapsible extends Component {
  state = { collapsed: true }
  getHeight = () => this.height
  getCollapsed = () => {
    const { collapsed = this.state.collapsed } = this.props
    return collapsed
  }
  height = null
  toggle = () => {
    if (this.props.onChange) this.props.onChange(!this.getCollapsed())
    else this.setState({ collapsed: !this.getCollapsed() })
  }
  render() {
    const collapsed = this.getCollapsed()
    const { collapsedHeight, children, className } = this.props
    const height = this.getHeight()
    return (
      <div
        aria-expanded={collapsed ? 'false' : 'true'}
        style={collapsed ? { height: collapsedHeight } : { height }}
        className={className}
        onClick={this.toggle}
        tabIndex={0}
        onKeyPress={evt => {
          if (evt.charCode === 32 || evt.keyCode === 13) {
            // spacebar or enter
            evt.preventDefault()
            this.toggle()
          }
        }}
        ref={rf => {
          if (!rf || this.height) return
          requestAnimationFrame(() => {
            const ref = rf
            const bckp = ref.style.height
            ref.style.height = 'auto'
            this.height = ref.getBoundingClientRect().height
            ref.style.height = bckp
          })
        }}
      >
        {children}
      </div>
    )
  }
}

const Card = Card_.extend`
  transition: height 0.5s ease-in-out;
  overflow: hidden;
  margin-top: 10px;
  padding: 0 0 0 0;
  position: relative;
  :focus {
    outline-color: #4d90fe;
    outline-style: solid;
    outline-width: 1px;
  }
`.withComponent(ClickCollapsible)

const CardLeftColumn = styled.div`
  padding: 5px 78px 30px 30px;
`

const Arrow = styled.div`
  transform: ${props =>
    props.down
      ? 'translateY(-50%) rotate(0deg)'
      : 'translateY(-50%) rotate(180deg)'};
  width: 58px;
  height: 68px;
  background: url(${arrow}) center no-repeat;
  filter: invert(100%);
  transition: transform 0.5s ease-in-out;
  position: absolute;
  top: 50%;
  right: 10px;
`

const Header = styled.h4`
  display: flex;
`
const Title = styled.div`
  flex-grow: 1;
`

export default class PoliticianSection extends Component {
  state = { collapsed: true }
  render() {
    const { title, text, vote, options } = this.props
    const { collapsed } = this.state
    return (
      <Card
        withHeader
        collapsedHeight={78}
        collapsed={collapsed}
        onChange={val => this.setState({ collapsed: val })}
      >
        <CardLeftColumn>
          <Header>
            <Title>{title}</Title>
            <div>{(options.find(o => o.id === vote) || {}).text || ''}</div>
          </Header>
          <InnerHTMLHelper tagName="span" html={text} />
        </CardLeftColumn>
        <Arrow down={collapsed} top={collapsed ? 0 : '50%'} />
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/politician/politician-votepoint.js